
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  name: 'AppHeaderNotice',
  props: {
    noticesCount: {
      type: Number,
      default: 0
    },
    hasNewNotice: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState(['api']),
    ...mapGetters('widget', ['device'])
  },
  methods: {
    ...mapActions('dialog', ['openBrandNoticesDialog'])
  }
};
